<template>
  <div class="withdraw">
    <div class="edit">
      <p class="title">提现</p>
      <el-form :model="info" :rules="rules" ref="info" label-width="95px" class="demo-ruleForm">
        <el-form-item
                label="持卡人："
                prop="name"
        >
          <el-input v-model="info.name" autocomplete="off" placeholder="请输入持卡人姓名"></el-input>
        </el-form-item>
        <el-form-item
                label="银行："
                prop="bankName"
        >
          <el-select v-model="info.bankName" placeholder="请选择银行">
            <el-option :label="item.name" :value="item.name" v-for="(item, index) in bankList" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
                label="卡号："
                prop="bankCard"
        >
          <el-input v-model="info.bankCard" autocomplete="off" placeholder="请输入卡号"></el-input>
        </el-form-item>
        <el-form-item
                label="提现金额："
                prop="withdrawMoney"
        >
          <el-input v-model="info.withdrawMoney" autocomplete="off" placeholder="请输入提现金额"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn" @click="submitForm('info')">提现</el-button>
        </el-form-item>
      </el-form>
      <img class="icon" src="../../assets/images/courier/close.png" alt="" @click="close">
    </div>
  </div>
</template>

<script>
import {reqSend, reqBankList, reqWithdraw} from '../../api'
export default {
  props: ['oldMobile'],
  data () {
    let validCard = (rule, value, callback) => {
      let reg = /^([1-9]{1})(\d{14}|\d{18})$/
/*      if(!reg.test(value.trim())){
        callback(new Error('银行卡号不正确'))
      }else{
        callback()
      }*/
     callback()
    }
    return {
      info:{
        name: '',
        bankName: '',
        bankCard: '',
        withdrawMoney: '',
      },
      bankList: [],
      rules: {
        name:[{ required: true, message: '请输入持卡人姓名', trigger: 'blur' }],
        bankName:[{ required: true, message: '请选择银行', trigger: 'change' }],
        bankCard:[{ required: true, message: '请输入卡号', trigger: 'blur' },{validator: validCard, trigger: 'blur'}],
        withdrawMoney:[{ required: true, message: '请输入提现金额', trigger: 'blur' }],
      }
    }
  },
  created() {
    this.info.oldMobile = this.oldMobile
    reqBankList('bank').then(res => {
      if(res.code === 200){
        this.bankList = res.data.bussData
      }
    })
  },
  methods: {
    // 关闭
    close () {
      this.$emit('close')
    },
    // 获取验证码
    getCode() {
      let query = '?mobile='+this.info.newMobile
      reqSend(query).then(res => {
        console.log(res)
      })
    },
    // 提交信息
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // let data = `?name=${this.info.name}&bankName=${this.info.bankName}&bankCard=${this.info.bankCard}&withdrawMoney=${this.info.withdrawMoney}`
          reqWithdraw(this.info).then(res => {
            console.log(res)
            if(res.code === 200){
              this.$message({
                message: '提现成功',
                type: 'success'
              })
              this.$emit('close')
            }else if(res.code === 500){
              this.$message({
                message: res.data.errMsg,
                type: 'error'
              })
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="less" type="text/less">
  .withdraw{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    z-index: 1000;
    .edit{
      position: relative;
      margin:100px auto;
      padding-top:50px;
      width: 535px;
      height: 460px;
      box-sizing: border-box;
      background: #fff;
      .title{
        margin-bottom: 43px;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        color: #2c2c2c;
      }
      .demo-ruleForm{
        padding:0 44px;
        .code{
          width: 235px;
        }
        .codeBtn{
          background: #ccc;
          color: #fff;
        }
        .btn{
          display: block;
          width: 200px;
          height: 46px;
          margin:20px auto 0;
          background: #61aee6;
          border-radius: 23px;
          font-size: 16px;
          font-weight: bold;
          border:none;
          color: #ffffff;
        }
      }
      .icon{
        position: absolute;
        top: 13px;
        right: 16px;
        cursor: pointer;
      }
    }
    .el-select{
     display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Person/Withdraw.vue